// extracted by mini-css-extract-plugin
export default {"list":"curious-mind_list__IlKmC","arrow_icon":"curious-mind_arrow_icon__jEj0J","subtitle":"curious-mind_subtitle__0FqSS"};